<h1 mat-dialog-title>Algo deu errado!</h1>
<div mat-dialog-content>
  <p class="error-message">Reinicie a pagina e tente novamente.</p>
</div>
<div mat-dialog-actions class="button-error-modal">
  <button mat-raised-button mat-dialog-close color="primary">Close</button>
</div>
